var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// src/services/system/OrbEmitter.ts
import * as THREE from 'three';
import { global } from '../../core/GlobalState';
import { scheduleOrbSpawn } from './OrbSpawnScheduler';
//TODO put somewhere else
export function sprayOrbsOld(scene, startPosition, baseDirection, sprayCoefficient, orbs, timeGap) {
    return __awaiter(this, void 0, void 0, function* () {
        //These are currently global variables
        //const orbManager = OrbManager.getInstance();
        //const scene = SceneManager.getInstance().getScene();
        for (const orb of orbs) {
            // Ensure the orb is created and positioned at the start location
            orb.setPosition(startPosition.clone());
            // Randomize the direction within the spray coefficient bounds
            const randomizedDirection = baseDirection.clone().add(new THREE.Vector3((Math.random() - 0.5) * sprayCoefficient, (Math.random() - 0.5) * sprayCoefficient, // Prevent excessive upward bias
            (Math.random() - 0.5) * sprayCoefficient)).normalize();
            const ballSpeed = 5;
            // Apply initial velocity to the orb
            const speedMultiplier = ballSpeed * (Math.random() * 2.6 + 0.5); // Random speed
            const velocity = randomizedDirection.multiplyScalar(speedMultiplier);
            orb.addVelocity(velocity);
            // Add orb to scene and track in OrbManager    
            global.orbManager.addOrbToScene(orb);
            // Wait for the specified time gap before processing the next orb
            yield new Promise(resolve => setTimeout(resolve, timeGap));
        }
    });
}
export function sprayOrbsRefactored(origin, direction, orbs, options = {}) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const { sprayCoefficient = 2000, timeGap = global.baseTimeGap, baseVelocity = 5, scene = global.scene, originAttachment, } = options;
        const MIN_TIME_GAP_MS = 120;
        const MAX_TIME_GAP_MS = 2400;
        const BASE_MULTIPLIER = 1.35;
        const burstPenalty = 1 + Math.max(0, orbs.length - 80) / 140;
        const saturationPenalty = 1 + Math.max(0, orbs.length - 220) / 220;
        const globalOrbPenalty = 1 + Math.max(0, global.orbManager.getAllOrbs().length - 350) / 500;
        const effectiveGap = Math.min(MAX_TIME_GAP_MS, Math.max(MIN_TIME_GAP_MS, timeGap * BASE_MULTIPLIER * burstPenalty * saturationPenalty * globalOrbPenalty));
        const sceneName = (_a = global.sceneManager.getSceneNameByInstance(scene)) !== null && _a !== void 0 ? _a : global.sceneManager.getCurrentSceneName();
        const start = typeof performance !== 'undefined' && typeof performance.now === 'function'
            ? performance.now()
            : Date.now();
        const tasks = [];
        let availableAt = start;
        for (const orb of orbs) {
            tasks.push(scheduleOrbSpawn({
                orb,
                origin: origin.clone(),
                direction: direction.clone(),
                sprayCoefficient,
                baseVelocity,
                drag: options.drag,
                sceneName,
                originAttachment,
                availableAt,
            }));
            availableAt += effectiveGap;
        }
        yield Promise.all(tasks);
    });
}
